import React from "react";
import {KochstatusAnzeige} from "../../../pages/rezept-cooking";

export function FooterMainDesktop() {
    return (<KochstatusAnzeige/>)
}
